let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("91bYA")).then(() => parcelRequire('7UsxD'));